import {
  ApiMutualFundAssetRead,
  ApiSegregatedPortfolioAssetRead
} from '../../../../../../api/rtk-api'
import {
  Fees,
  FormItem,
  Label,
  ProtectionAssetSelector,
  Section,
  SliderWithTextInput,
  Space,
  ValidationMessage
} from '../../../../../../components/core-v2'
import { Errors } from '../../../../util'
import { StyledCharges } from '../../../01-note/existing-note/details-summary/primitives'
import { StyledChargesBlock } from '../../primitives'

type RiskManagedEditorProps = {
  assets: (ApiMutualFundAssetRead | ApiSegregatedPortfolioAssetRead)[]
  errors: Errors
  fees: any
  isGeneratingCharts: boolean
  maxVolatility: number
  minVolatility: number
  onChangeTargetVolatility: (value: string) => void
  onInspectAsset: (asset: ApiMutualFundAssetRead | ApiSegregatedPortfolioAssetRead) => void
  onSelectAsset: (asset: ApiMutualFundAssetRead | ApiSegregatedPortfolioAssetRead) => void
  selectedAsset?: ApiMutualFundAssetRead | ApiSegregatedPortfolioAssetRead
  targetVolatility: number
}

export function RiskManagedEditorDumb({
  assets,
  errors,
  fees,
  isGeneratingCharts,
  maxVolatility,
  minVolatility,
  onChangeTargetVolatility,
  onInspectAsset,
  onSelectAsset,
  selectedAsset,
  targetVolatility
}: RiskManagedEditorProps) {
  return (
    <fieldset disabled={isGeneratingCharts}>
      <Space mx={5} my={6}>
        <FormItem>
          <Label>Target volatility (%)</Label>
          <SliderWithTextInput
            data-testid="target-volatility"
            max={maxVolatility}
            min={minVolatility}
            step={0.25}
            value={targetVolatility}
            onChange={v => onChangeTargetVolatility(v)}
          />
          <ValidationMessage errors={errors} fieldName="targetVolatility" />
        </FormItem>
      </Space>
      <Space mb={6} mx={5}>
        <ProtectionAssetSelector
          asset={selectedAsset}
          assets={assets}
          onInspectAsset={onInspectAsset}
          onSelectAsset={asset => onSelectAsset(asset)}
        />
      </Space>

      <ValidationMessage errors={errors} fieldName="riskManaged_protectionAsset" />

      {Array.isArray(fees) && (
        <Space mx={5} my={6}>
          <StyledChargesBlock>
            <Section type="secondary">
              <StyledCharges>
                <Fees fees={fees} title="Charges" />
              </StyledCharges>
            </Section>
          </StyledChargesBlock>
        </Space>
      )}
    </fieldset>
  )
}
